import i18n, { type i18n as I18nInstance } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import enTranslations from './locales/en/translation.json'
import svTranslations from './locales/sv/translation.json'

let cachedInstance: I18nInstance | null = null

export const getI18nInstance = (): I18nInstance => {
    if (cachedInstance) {
        return cachedInstance
    }

    i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            resources: {
                en: { translation: enTranslations },
                sv: { translation: svTranslations },
            },
            fallbackLng: ['sv', 'en'],
            supportedLngs: ['sv', 'en'],
            defaultNS: 'translation',
            interpolation: {
                escapeValue: false,
            },
            detection: {
                order: ['querystring', 'localStorage', 'navigator'],
                caches: ['localStorage'],
            },
            returnNull: false,
        })

    cachedInstance = i18n

    return i18n
}